import {
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_RESET,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_GOOGLE_LOGIN_FAIL,
  USER_GOOGLE_LOGIN_REQUEST,
  USER_GOOGLE_LOGIN_SUCCESS,
} from "../Constants/UserContants";
import { ORDER_LIST_MY_RESET } from "../Constants/OrderConstants";
import URL from "../Url";

// LOGIN
export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const res = await fetch(`${URL}/api/users/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Login failed");

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({ type: USER_LOGIN_FAIL, payload: error.message });
  }
};

// LOGOUT
export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  dispatch({ type: USER_LOGOUT });
  dispatch({ type: USER_DETAILS_RESET });
  dispatch({ type: ORDER_LIST_MY_RESET });
  document.location.href = "/";
};

// REGISTER
export const register = (username, name, email, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });

    const res = await fetch(`${URL}/api/users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, name, email, password }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Registration failed");

    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({ type: USER_REGISTER_FAIL, payload: error.message });
  }
};

// GOOGLE LOGIN
export const googleLogin = (credential, nonce) => async (dispatch) => {
  try {
    dispatch({ type: USER_GOOGLE_LOGIN_REQUEST });

    const res = await fetch(`${URL}/api/users/google`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ credential, nonce }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Google login failed");

    dispatch({ type: USER_GOOGLE_LOGIN_SUCCESS, payload: data });
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({ type: USER_GOOGLE_LOGIN_FAIL, payload: error.message });
  }
};

// USER DETAILS
export const getUserDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_DETAILS_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/users/${id}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to get user details");

    dispatch({ type: USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: USER_DETAILS_FAIL, payload: error.message });
  }
};

// UPDATE PROFILE
export const updateUserProfile = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_UPDATE_PROFILE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/users/profile`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
      body: JSON.stringify(user),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to update profile");

    dispatch({ type: USER_UPDATE_PROFILE_SUCCESS, payload: data });
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: USER_UPDATE_PROFILE_FAIL, payload: error.message });
  }
};

// GET CUSTOMER DETAILS
export const getCustomerDetails = () => async (dispatch, getState) => {
  try {
    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/customers/profile`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Failed to get customer details");

    return data;
  } catch (error) {
    console.error("Error fetching customer details:", error.message);
    return null;
  }
};